import { ComposeViewState, ComposeStore, getStore } from 'owa-mail-compose-store';
import { getActiveContentTab, TabType, TabViewState } from 'owa-tab-store';

export default function getFullComposeShowingInTabContentArea(): ComposeViewState {
    const activeTab = getActiveContentTab();
    const store = getStore();
    const composeId = activeTab ? getComposeIdFromTab(activeTab, store) : store.primaryComposeId;
    const viewState = composeId ? store.viewStates.get(composeId) : null;
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (12,5): Type 'ComposeViewState | null' is not assignable to type 'ComposeViewState'.
    // @ts-expect-error
    return viewState && !viewState.isInlineCompose ? viewState : null;
}

function getComposeIdFromTab(tab: TabViewState, store: ComposeStore): string | null {
    switch (tab.type) {
        case TabType.Primary:
            return store.primaryComposeId;
        case TabType.MailCompose:
            return tab.data;
        default:
            return null;
    }
}
